import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import { Input } from 'components/Controls';

const RegistrationCaption = () => {
  const { t } = useTranslation('common');

  const { control, formState:{ errors } } = useFormContext();

  return (
    <Controller
      control={control} name="registrationPage.caption"
      render={({ field }) => (
        <Input
          {...field}
          label={t('ownerPage.quizForm.registrationCaption')} id="registrationCaption"
          error={Boolean(errors.registrationCaption)}
          errorText={errors.registrationCaption ? (errors as any).registrationCaption.message : ''}
          helperText={t('ownerPage.quizForm.registrationCaptionHint')}
        />
      )}
    />
  )
}

export default RegistrationCaption;
